// Human name for a market. `display_name` is optional (decision D1); until it
// exists the id-like `name` is shown, exactly as today.
export const resourceDisplayName = (resource) => resource?.display_name || resource?.name || '';
